import { gql } from '@apollo/client';

export default gql`
  query getCustomersRaseeds($start: Date, $end: Date) {
    getCustomersRaseeds(start: $start, end: $end) {
      ok
      error
      data
      message
    }
  }
`;
